<ng-container [formGroup]="group">
  <mat-label>{{field.localeText.name}}<span *ngIf="field.required">*</span></mat-label>
  <!-- <label id="example-radio-group-label">{{field.localeText.name}}<span *ngIf="field.required">*</span></label> -->
  <mat-radio-group aria-label="Select an option" [formControlName]="field.fieldKey">
    <mat-radio-button [color]="'primary'" *ngFor="let item of field.localeText.attributes" [value]="item.key">
      {{item.value}}
    </mat-radio-button>
  </mat-radio-group>
  <ng-container *ngIf="(
      group.get(field.fieldKey).dirty ||
      group.get(field.fieldKey).touched
     )" ngProjectAs="mat-error">
    <div class="mat-form-field">
      <div class="mat-form-field-subscript-wrapper" style="opacity: 1; transform: translateY(0%);">
        <ng-container *ngFor="let validation of field.validation;" ngProjectAs="mat-error">
          <mat-error *ngIf="group.get(field.fieldKey).hasError(validation.name)">
            {{validation.message}}
          </mat-error>
        </ng-container>
      </div>
    </div>
  </ng-container>
</ng-container>
